import { useEffect } from 'react';
import kolamrenangbali from '../img/pool-service.jpg';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FaMapMarkerAlt, FaExternalLinkAlt } from 'react-icons/fa';
import { WA_NUMBER } from '../constant/detail';

const stores = [
  {
    name: 'Pool Shop SJT - Ubud',
    url: 'https://goo.gl/maps/yPiN7QVSgGT7akcn8',
  },
  {
    name: 'Pool Shop SJT - Lodtunduh',
    url: 'https://maps.app.goo.gl/gebnMK1ijneC67Yu9',
  },
];

const InfoSection = () => {
  useEffect(() => {
    AOS.init({
      once: false,
      mirror: true,
    });
  }, []);

  const highlights = [
    "We assess your pool's condition and setup.",
    'We deliver trusted, safe, and effective pool chemicals.',
    'We handle all routine maintenance and system upkeep.',
    'You save time, reduce stress, and focus on growing your business.',
  ];

  return (
    <section className="bg-white py-10 px-4 sm:px-8 lg:px-20">
      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-8">
        {/* Image */}
        <div
          className="w-full lg:w-1/2"
          data-aos="flip-left"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="2000"
        >
          <div className="relative overflow-hidden shadow-xl">
            <img
              className="w-full h-64 sm:h-80 lg:h-[420px] object-cover"
              src={kolamrenangbali}
              alt="Swimming Pool Service Bali"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
            <span className="absolute bottom-4 right-4 bg-primary text-tertiary text-xs sm:text-sm font-semibold px-3 py-1 rounded-full">
              Trusted Pool Service Bali
            </span>
          </div>
        </div>

        {/* Text */}
        <div
          className="w-full lg:w-1/2"
          data-aos="fade-left"
          data-aos-duration="1000"
        >
          <span className="inline-block text-lg font-semibold tracking-widest text-primary uppercase">
            About Us
          </span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-tertiary leading-tight mb-2">
            Pool Shop <span className="text-primary">Surya Jaya Teknik</span>
          </h2>
          <p className="text-gray-600 leading-relaxed mb-1 text-base">
            Dirty water, green algae, or a broken pump can quickly turn your
            pool into a problem - upsetting guests and eating up your time. We
            are here to fix that.
          </p>
          <p className="text-gray-600 leading-relaxed mb-2 text-base">
            We provide pool chemicals and maintenance services for villas, guest
            houses, and resorts in Bali, keeping your pool clean, safe, and
            ready to use every day.
          </p>

          <ul className="list-disc list-inside space-y-0.5 mb-3">
            {highlights.map((text, i) => (
              <li key={i} className="text-gray-700 text-base">
                {text}
              </li>
            ))}
          </ul>

          <p className="text-base font-semibold text-tertiary border-l-4 border-primary pl-4 mb-4 italic">
            "Let us take care of your swimming pool so you can take care of your
            business."
          </p>

          <div className="flex flex-col sm:flex-row gap-3 mb-4">
            {stores.map((store) => (
              <a
                key={store.name}
                href={store.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Lihat lokasi ${store.name} di Google Maps`}
                className="flex items-center gap-2 border border-primary/40 text-tertiary text-sm font-medium px-4 py-2.5 rounded-full hover:bg-primary/10 transition group"
              >
                <FaMapMarkerAlt className="text-primary flex-shrink-0" />
                <span>{store.name}</span>
                <FaExternalLinkAlt className="text-primary/40 group-hover:text-primary text-xs ml-auto transition" />
              </a>
            ))}
          </div>

          <a
            href={`https://wa.me/${WA_NUMBER}`}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Hubungi Surya Jaya Teknik via WhatsApp"
            className="inline-flex items-center gap-2 bg-green-600 hover:opacity-90 active:opacity-80 text-white font-semibold px-6 py-3 rounded-full transition text-sm sm:text-base shadow-md hover:shadow-lg"
          >
            Contact Us via WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
};

export default InfoSection;
